// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary: #722bff;
  --secondary: #cc97f4;
  --background: #050518;
  --text: #FFFFFF;
  --text-secondary: #C4C4C4;
  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: var(--font-sans);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  font-family: var(--font-sans);
  background-color: var(--background);
  color: var(--text);
  line-height: 1.6;
}

h1, h2, h3, h4, h5, h6 {
  font-family: 'Inter', var(--font-sans);
  font-weight: 700;
}

.App {
  text-align: left;
  min-height: 100vh;
}

.container {
  max-width: 90%;
  margin: 0 auto;
}

.gradient-text {
  color: #FFF;
}

.button {
  position: relative;
  padding: 12px 24px;
  border-radius: 100px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: var(--font-sans);
  text-decoration: none;
  background: transparent;
  border: none;
  z-index: 1;
}

.button::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 100px;
  padding: 1.5px;
  background: linear-gradient(45deg, var(--primary), var(--secondary));
  mask: 
    linear-gradient(#fff 0 0) content-box, 
    linear-gradient(#fff 0 0);
  mask-composite: exclude;
}

.button-primary {
  color: white;
  background: linear-gradient(45deg, var(--primary), var(--secondary));
}

.button-secondary {
  color: var(--text);
  background: var(--background);
}

.button:hover {
  transform: translateY(-2px);
}

.button:hover::before {
  background: linear-gradient(90deg, var(--secondary), var(--primary));
}

.section {
  padding: 80px 0;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,iJAAiJ;AACnJ;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,cAAc;EACd,oEAAoE;EAIpE;;6BAE2B;EAE3B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[":root {\n  --primary: #722bff;\n  --secondary: #cc97f4;\n  --background: #050518;\n  --text: #FFFFFF;\n  --text-secondary: #C4C4C4;\n  --font-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: var(--font-sans);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n  font-family: var(--font-sans);\n  background-color: var(--background);\n  color: var(--text);\n  line-height: 1.6;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: 'Inter', var(--font-sans);\n  font-weight: 700;\n}\n\n.App {\n  text-align: left;\n  min-height: 100vh;\n}\n\n.container {\n  max-width: 90%;\n  margin: 0 auto;\n}\n\n.gradient-text {\n  color: #FFF;\n}\n\n.button {\n  position: relative;\n  padding: 12px 24px;\n  border-radius: 100px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-family: var(--font-sans);\n  text-decoration: none;\n  background: transparent;\n  border: none;\n  z-index: 1;\n}\n\n.button::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 100px;\n  padding: 1.5px;\n  background: linear-gradient(45deg, var(--primary), var(--secondary));\n  -webkit-mask: \n    linear-gradient(#fff 0 0) content-box, \n    linear-gradient(#fff 0 0);\n  mask: \n    linear-gradient(#fff 0 0) content-box, \n    linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n}\n\n.button-primary {\n  color: white;\n  background: linear-gradient(45deg, var(--primary), var(--secondary));\n}\n\n.button-secondary {\n  color: var(--text);\n  background: var(--background);\n}\n\n.button:hover {\n  transform: translateY(-2px);\n}\n\n.button:hover::before {\n  background: linear-gradient(90deg, var(--secondary), var(--primary));\n}\n\n.section {\n  padding: 80px 0;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
